import { api } from "@/lib/api";
import { log } from "@/lib/logger";
import { toast } from "sonner";
import { FileDown, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";

/**
 * Downloads a PDF from the given endpoint using authenticated axios.
 * `endpoint` is relative to /api (e.g. `/customer-quotations/{id}/pdf`).
 */
export default function PdfDownloadButton({ endpoint, filename, label = "تحميل PDF", variant = "outline", className = "", "data-testid": dataTestId }) {
  const [busy, setBusy] = useState(false);
  const handle = async () => {
    setBusy(true);
    try {
      const res = await api.get(endpoint, { responseType: "blob" });
      const blobUrl = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename || "merqav-document.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      toast.error("تعذر توليد ملف PDF");
      log.error("PDF download failed:", err);
    }
    setBusy(false);
  };
  return (
    <Button type="button" variant={variant} className={className} onClick={handle} disabled={busy} data-testid={dataTestId}>
      {busy ? <Loader2 className="w-4 h-4 animate-spin me-1" /> : <FileDown className="w-4 h-4 me-1" />}
      {label}
    </Button>
  );
}
